import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Returns `true` when the user has asked the OS to minimise non-essential
 * motion. Celebration surfaces use this to skip confetti and overshoot
 * animations entirely rather than relying on the CSS guard alone — some
 * effects (e.g. mounting 24 absolutely-positioned confetti pieces) are
 * better not rendered at all.
 *
 * SSR-safe: starts `false` on the server and first client paint, then
 * syncs on mount. Celebration UI is client-only, so no hydration mismatch.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(QUERY);
    setReduced(mql.matches);
    const onChange = (event: MediaQueryListEvent) => setReduced(event.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
